export default __webpack_public_path__ + "static/error-61c53ea500892077eec14ca83e7003a8.svg";